import { Col, message, Row } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import {
  createDocumentLibrary,
  DocumentLibraryInput,
} from "../../../lib/api/resources/documentLibraries";
import { DocumentLibraryFormCard } from "./components/DocumentLibraryFormCard";

export const DocumentLibraryCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createDocumentLibraryMutation = useMutation({
    mutationFn: (data: DocumentLibraryInput) => createDocumentLibrary(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["documentLibraries"],
      });
      message.success("Bibliotheek succesvol aangemaakt");
      navigate("/document-libraries");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het aanmaken van de bibliotheek",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <DocumentLibraryFormCard mutation={createDocumentLibraryMutation} />
      </Col>
    </Row>
  );
};
